// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { doc, getDoc, updateDoc } from 'firebase/firestore';
// import { getAuth, onAuthStateChanged, updateProfile } from 'firebase/auth';
// import { db } from '../../firebase/firebaseConfig';
// import './EditProfilePage.css';

// const EditProfilePage = () => {
//   const navigate = useNavigate();
//   const auth = getAuth();
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState(null);
//   const [successMessage, setSuccessMessage] = useState('');
  
//   // Form state
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     deliveryAddress: ''
//   });
  
//   // Validation state
//   const [validation, setValidation] = useState({
//     name: { valid: true, message: '' },
//     phone: { valid: true, message: '' },
//     deliveryAddress: { valid: true, message: '' }
//   });

//   useEffect(() => {
//     const fetchUserData = async (user) => {
//       try {
//         if (!user || !user.uid) {
//           throw new Error('User not authenticated');
//         }
        
//         // Set initial user data from auth
//         setFormData(prevData => ({
//           ...prevData,
//           email: user.email || '',
//           name: user.displayName || ''
//         }));
        
//         // Fetch complete user data from Firestore
//         try {
//           const userDocRef = doc(db, 'users', user.uid);
//           const userDocSnap = await getDoc(userDocRef);
          
//           if (userDocSnap.exists()) {
//             const firestoreData = userDocSnap.data();
            
//             setFormData(prevData => ({
//               ...prevData,
//               name: firestoreData.name || prevData.name,
//               phone: firestoreData.phone || '',
//               deliveryAddress: firestoreData.deliveryAddress || ''
//             }));
//           }
//         } catch (firestoreError) {
//           console.error("Error fetching user data from Firestore:", firestoreError);
//         }
        
//       } catch (error) {
//         console.error("Error in edit profile page:", error);
//         setError(error.message);
//       } finally {
//         setLoading(false);
//       }
//     };
    
//     // Use Firebase Auth state
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       if (user) {
//         fetchUserData(user);
//       } else {
//         // User is not logged in
//         setLoading(false);
//         navigate('/login');
//       }
//     });
    
//     // Cleanup subscription
//     return () => unsubscribe();
//   }, [navigate, auth]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prevData => ({
//       ...prevData,
//       [name]: value
//     }));
    
//     // Clear any validation errors when user types
//     if (validation[name] && !validation[name].valid) {
//       setValidation(prev => ({
//         ...prev,
//         [name]: { valid: true, message: '' }
//       }));
//     }
    
//     // Clear success message when form is edited
//     if (successMessage) {
//       setSuccessMessage('');
//     }
//   };

//   const validateForm = () => {
//     const newValidation = { ...validation };
//     let isValid = true;
    
//     // Validate name
//     if (!formData.name.trim()) {
//       newValidation.name = {
//         valid: false,
//         message: 'Name is required'
//       };
//       isValid = false;
//     }
    
//     // Validate phone (if provided)
//     if (formData.phone && !/^\d{10,15}$/.test(formData.phone.replace(/[+\s-]/g, ''))) {
//       newValidation.phone = {
//         valid: false,
//         message: 'Please enter a valid phone number'
//       };
//       isValid = false;
//     }
    
//     // Validate address (if provided)
//     if (formData.deliveryAddress && formData.deliveryAddress.trim().length < 5) {
//       newValidation.deliveryAddress = {
//         valid: false,
//         message: 'Please enter a complete address'
//       };
//       isValid = false;
//     }
    
//     setValidation(newValidation);
//     return isValid;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     // Reset error and success states
//     setError(null);
//     setSuccessMessage('');
    
//     // Validate form
//     if (!validateForm()) {
//       return;
//     }
    
//     setSaving(true);
    
//     try {
//       const user = auth.currentUser;
      
//       if (!user) {
//         throw new Error('User not authenticated');
//       }
      
//       // Update user profile in Firebase Auth (just the name)
//       if (user.displayName !== formData.name) {
//         await updateProfile(user, {
//           displayName: formData.name
//         });
//       }
      
//       // Update user data in Firestore
//       const userDocRef = doc(db, 'users', user.uid);
      
//       await updateDoc(userDocRef, {
//         name: formData.name,
//         phone: formData.phone,
//         deliveryAddress: formData.deliveryAddress,
//         updatedAt: new Date()
//       });
      
//       setSuccessMessage('Profile updated successfully!');
      
//       // Scroll to top to show success message
//       window.scrollTo(0, 0);
      
//     } catch (error) {
//       console.error("Error updating profile:", error);
//       setError(error.message || 'Failed to update profile. Please try again.');
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleCancel = () => {
//     navigate('/profile');
//   };

//   if (loading) {
//     return (
//       <div className="edit-profile-container">
//         <div className="loading-spinner"></div>
//         <p>Loading your profile...</p>
//       </div>
//     );
//   }

//   if (error && !formData.name) {
//     return (
//       <div className="edit-profile-container">
//         <div className="error-message">
//           <h2>Error loading profile</h2>
//           <p>{error}</p>
//           <button 
//             className="action-button"
//             onClick={() => navigate('/profile')}
//           >
//             Back to Profile
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="edit-profile-container">
//       <h1>Edit Profile</h1>
      
//       {successMessage && (
//         <div className="success-message">
//           <p>{successMessage}</p>
//         </div>
//       )}
      
//       {error && (
//         <div className="form-error-message">
//           <p>{error}</p>
//         </div>
//       )}
      
//       <form onSubmit={handleSubmit} className="edit-profile-form">
//         <div className="form-group">
//           <label htmlFor="name">Name *</label>
//           <input
//             type="text"
//             id="name"
//             name="name"
//             value={formData.name}
//             onChange={handleInputChange}
//             className={!validation.name.valid ? 'input-error' : ''}
//             placeholder="Your full name"
//             required
//           />
//           {!validation.name.valid && (
//             <p className="error-text">{validation.name.message}</p>
//           )}
//         </div>
        
//         <div className="form-group">
//           <label htmlFor="email">Email</label>
//           <input
//             type="email"
//             id="email"
//             name="email"
//             value={formData.email}
//             disabled
//             className="disabled-input"
//             title="Email cannot be changed. Please contact support for assistance."
//           />
//           <p className="help-text">Email cannot be changed through this form</p>
//         </div>
        
//         <div className="form-group">
//           <label htmlFor="phone">Phone</label>
//           <input
//             type="tel"
//             id="phone"
//             name="phone"
//             value={formData.phone}
//             onChange={handleInputChange}
//             className={!validation.phone.valid ? 'input-error' : ''}
//             placeholder="Your phone number"
//           />
//           {!validation.phone.valid && (
//             <p className="error-text">{validation.phone.message}</p>
//           )}
//         </div>
        
//         <div className="form-group">
//           <label htmlFor="deliveryAddress">Delivery Address</label>
//           <textarea
//             id="deliveryAddress"
//             name="deliveryAddress"
//             value={formData.deliveryAddress}
//             onChange={handleInputChange}
//             className={!validation.deliveryAddress.valid ? 'input-error' : ''}
//             placeholder="Your delivery address"
//             rows="3"
//           />
//           {!validation.deliveryAddress.valid && (
//             <p className="error-text">{validation.deliveryAddress.message}</p>
//           )}
//         </div>
        
//         <div className="form-actions">
//           <button
//             type="button"
//             className="cancel-btn"
//             onClick={handleCancel}
//             disabled={saving}
//           >
//             Cancel
//           </button>
          
//           <button
//             type="submit"
//             className="save-btn"
//             disabled={saving}
//           >
//             {saving ? 'Saving...' : 'Save Changes'}
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default EditProfilePage;







import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, updateProfile } from 'firebase/auth';
import { doc, updateDoc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig';
import { FaSpinner, FaExclamationTriangle } from 'react-icons/fa';
// Import your CSS file - we'll create this file in the same directory
import './EditProfilePage.css';

const EditProfilePage = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [deliveryAddress, setDeliveryAddress] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  const auth = getAuth();

  // Load user data
  useEffect(() => {
    const loadUserData = async () => {
      setLoading(true);
      
      try {
        // First try to load from localStorage for instant display
        const storedUserData = localStorage.getItem('userData');
        let userData = null;
        
        if (storedUserData) {
          try {
            userData = JSON.parse(storedUserData);
            
            // Populate form fields with stored data
            setName(userData.name || '');
            setEmail(userData.email || '');
            setPhone(userData.phone || '');
            setDeliveryAddress(userData.deliveryAddress || '');
          } catch (parseError) {
            console.warn("Failed to parse stored user data:", parseError);
          }
        }
        
        // Then try to get fresh data if user is authenticated
        const user = auth.currentUser;
        
        if (user) {
          try {
            // Get fresh data from Firestore
            const userDoc = await getDoc(doc(db, 'users', user.uid));
            
            if (userDoc.exists()) {
              const firestoreData = userDoc.data();
              
              // Update form fields with Firestore data
              setName(firestoreData.name || user.displayName || '');
              setEmail(firestoreData.email || user.email || '');
              setPhone(firestoreData.phone || '');
              setDeliveryAddress(firestoreData.deliveryAddress || '');
            }
          } catch (firestoreError) {
            console.warn("Error loading user data from Firestore:", firestoreError);
            // Continue with data from localStorage or Auth
          }
        } else {
          // No authenticated user, redirect to login
          navigate('/login');
        }
      } catch (error) {
        console.error("Error loading profile data:", error);
        setError("Failed to load profile data. Please try again.");
      } finally {
        setLoading(false);
      }
    };
    
    loadUserData();
  }, [auth, navigate]);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError(null);
    setSuccess(false);
    
    try {
      const user = auth.currentUser;
      
      if (!user) {
        throw new Error("You must be logged in to update your profile.");
      }
      
      // Validate form data
      if (!name.trim()) {
        throw new Error("Name is required.");
      }
      
      // Validate phone number (10 digits)
      const phoneRegex = /^[0-9]{10}$/;
      if (!phoneRegex.test(phone)) {
        throw new Error("Please enter a valid 10-digit phone number.");
      }
      
      // Validate delivery address
      if (!deliveryAddress.trim()) {
        throw new Error("Delivery address is required.");
      }
      
      // Update user profile in Firebase Auth (display name)
      try {
        await updateProfile(user, {
          displayName: name
        });
      } catch (authError) {
        console.warn("Failed to update Auth profile:", authError);
        // Continue anyway
      }
      
      // Update user data in Firestore
      try {
        await updateDoc(doc(db, 'users', user.uid), {
          name,
          phone,
          deliveryAddress,
          updatedAt: new Date()
        });
      } catch (firestoreError) {
        console.error("Failed to update Firestore profile:", firestoreError);
        throw new Error("Failed to save profile changes. Please try again.");
      }
      
      // Update local storage data
      try {
        const storedUserData = localStorage.getItem('userData');
        
        if (storedUserData) {
          const userData = JSON.parse(storedUserData);
          
          // Update with new values
          userData.name = name;
          userData.phone = phone;
          userData.deliveryAddress = deliveryAddress;
          
          // Save back to localStorage
          localStorage.setItem('userData', JSON.stringify(userData));
        }
        
        // Update location data
        localStorage.setItem('userLocation', JSON.stringify({
          address: deliveryAddress,
          formattedAddress: deliveryAddress
        }));
      } catch (storageError) {
        console.warn("Failed to update localStorage:", storageError);
        // Non-critical error, continue
      }
      
      // Show success message
      setSuccess(true);
      
      // Trigger profile refresh event
      window.dispatchEvent(new Event('refreshProfile'));
      
      // Navigate back to profile page after a short delay to show success message
      setTimeout(() => {
        navigate('/profile');
      }, 1500);
      
    } catch (error) {
      console.error("Error updating profile:", error);
      setError(error.message || "Failed to update profile. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  // Handle cancel button
  const handleCancel = () => {
    navigate('/profile');
  };

  if (loading) {
    return (
      <div className="edit-profile-container">
        <div className="edit-profile-loading">
          <FaSpinner className="spinner" />
          <p>Loading profile data...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="edit-profile-container">
      <h1>Edit Profile</h1>
      
      {success && (
        <div className="success-message">
          Profile updated successfully!
        </div>
      )}
      
      {error && (
        <div className="error-message">
          <FaExclamationTriangle className="error-icon" />
          {error}
        </div>
      )}
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">
            Name <span className="required">*</span>
          </label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            disabled={saving}
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            value={email}
            disabled={true}
          />
          <div className="form-help">Email cannot be changed through this form</div>
        </div>
        
        <div className="form-group">
          <label htmlFor="phone">
            Phone <span className="required">*</span>
          </label>
          <input
            type="tel"
            id="phone"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
            pattern="[0-9]{10}"
            disabled={saving}
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="deliveryAddress">
            Delivery Address <span className="required">*</span>
          </label>
          <textarea
            id="deliveryAddress"
            value={deliveryAddress}
            onChange={(e) => setDeliveryAddress(e.target.value)}
            required
            rows="3"
            disabled={saving}
          />
        </div>
        
        <div className="form-actions">
          <button
            type="button"
            className="cancel-btn"
            onClick={handleCancel}
            disabled={saving}
          >
            Cancel
          </button>
          
          <button
            type="submit"
            className="save-btn"
            disabled={saving}
          >
            {saving ? (
              <>
                <FaSpinner className="spinner" />
                <span>Saving...</span>
              </>
            ) : (
              'Save Changes'
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditProfilePage;